export default "/images/ic-check.svg?9cf9104d00ced9832b6d5653124f278f";